module.exports = __webpack_public_path__ + "img/facility5.5972e118.png";